import "./Loader.scss";
import LoaderSvg from "./Loader.svg";

const Loader = () => (
  <img className="loader" src={LoaderSvg} alt="loader animation" />
);

export default Loader;
